import * as types from './constants';

// Get Lookbook
export const getLookbookRequest = data => (
  { type: types.GET_LOOKBOOK_REQUEST, payload: data }
);

export const getLookbookDone = data => (
  { type: types.GET_LOOKBOOK_DONE, payload: data }
);

export const getLookbookFailed = errors => (
  { type: types.GET_LOOKBOOK_FAILED, payload: errors }
);